// ─────────────────────────────────────────────────────────────
//  Мелкие примитивы оформления приложения: стеклянная карточка, шарик-орб,
//  кнопка-пилюля, разделитель и формат денег.
//
//  Раньше они жили внутри main.jsx. Вынесены сюда, чтобы экраны из
//  components/ (например «Тарифы») выглядели ровно так же, а не повторяли
//  ту же разметку своими руками. Стили у всех классов глобальные (styles.css).
// ─────────────────────────────────────────────────────────────
import { Sparkles } from 'lucide-react'

const A = '/assets/'

export function Glass({ className = '', children }) {
  return <div className={`glass ${className}`}>{children}</div>
}

export function Orb({ className = '' }) {
  return <img className={`orb ${className}`} src={`${A}orb.webp`} alt="" />
}

export function Pill({ children, className = '', onClick, type = 'button', disabled = false, ...props }) {
  return (
    <button type={type} className={`pill press ${className}`} onClick={onClick} disabled={disabled} {...props}>
      {children}
    </button>
  )
}

export function SparkLine() {
  return <div className="spark-line"><span /><Sparkles size={24} /><span /></div>
}

/** 1234.50 → «1 235» (в рублях копейки в интерфейсе не показываем). */
export const money = value => new Intl.NumberFormat('ru-RU').format(Math.round(Number(value) || 0))
